import { useEffect, useState } from "react";
import { api, reloadConfig } from "../request/api";
import DataGrid, { Paging } from "devextreme-react/data-grid";
import { Column, SearchPanel } from "devextreme-react/data-grid";
import { EAgreementType } from "../Types/EAgreementType";
import { EkoBillingNavbar } from "../_components/EkoBillingNavbar/EkoBillingNavbar";
import DataSource from "devextreme/data/data_source";
import { EInvoiceType } from "../Types/EInvoiceType";
import { Button } from "devextreme-react/button";
import pdficon from "../_assets/pdf-icon.svg";
import { parse } from "path";
import notify from "devextreme/ui/notify";

const EInvoices = () => {
  const [eInvoices, setEInvoices] = useState<EInvoiceType[]>();

  const renderCell = (cellInfo: any) => {
    const { data } = cellInfo;
    return (
      <>
        <Button
          icon={pdficon}
          onClick={async () => {
            //
            let invhist_id = data.invhist_id;
            let invoiceId = data.id;
            let headers = new Headers();
            headers.append("Content-Type", "application/json");
            console.log(data);
            try {
              const { data } = await api.post<any>(
                "EInvoices/GetInvoiceFile",
                {
                  invhistId: invhist_id,
                  InvoiceId: invoiceId
                },
                //invhist_id,
                { responseType: "blob" }
              );
              var blob = new Blob([data], {
                type: "application/pdf",
              });
              console.log(data);

              var url = URL.createObjectURL(blob);

              window.open(url, "_blank");
            } catch {
              notify("Nie odnaleziono pliku", "error", 5000);
            }
          }}
          className="pdfButton"
          hint="Pobierz fakturę"
        />
      </>
    );
  };
  const getData = async () => {
    reloadConfig();
    const result = await api.get<EInvoiceType[]>("EInvoices/GetInvoices");
    setEInvoices(result.data);
  };
  useEffect(() => {


    getData();
  }, []);

  return (
    <>
      <div className="mainTitle">Moje faktury</div>
      <DataGrid
        id="gridContainer"
        dataSource={eInvoices}
        showBorders={true}
        selection={{ mode: "single" }}
        hoverStateEnabled={true}
      >
        <SearchPanel visible={true} width={240} placeholder="Wyszukaj..." />
        <Column dataField="inv_string_number" caption="Numer faktury" />
        <Column
          dataField="inv_write_date"
          dataType="date"
          caption="Data wystawienia"
          format="dd.MM.yyyy"
        />
        <Column
          dataField="inv_sale_date"
          dataType="date"
          caption="Data sprzedaży"
          format="dd.MM.yyyy"
        />
        <Column
          dataField="inv_maturity_date"
          dataType="date"
          caption="Termin płatności"
          format="dd.MM.yyyy"
        />
        <Column
          dataField="inv_maturity_string"
          dataType="date"
          caption="Termin płatności słownie"
          format="dd.MM.yyyy"
        />
        <Column
          dataField="invhist_link"
          caption="PDF"
          type="selection"
          cellRender={renderCell}
        />
        <Paging defaultPageSize={15} />
      </DataGrid>
    </>
  );
};

export { EInvoices };